import { render } from "./Physicians.vue?vue&type=template&id=90dbb170"
import script from "./Physicians.vue?vue&type=script&lang=js"
export * from "./Physicians.vue?vue&type=script&lang=js"
script.render = render

export default script